export const TABS_CAROUSEL_PRODUCT_CARD_MARKETING_ENDPOINT = 'homeshowcase/component/model';

//# sourceMappingURL=utils.js.map